import type { FoodUsageReportComponentProps } from './FoodUsageReportComponent';

export const FoodUsageReportComponent = {
    MountAsync: async (target: HTMLElement, props: FoodUsageReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { FoodUsageReportComponent } = await import('./FoodUsageReportComponent');
        return await mountReactComponentAsync(target, FoodUsageReportComponent, props);
    }
};

